export interface ILesson {
  id: string
  chapterId: string
  type: LessonType
  name: string
  description: string
  imageUrl: string
}

export interface ICreateLesson {
  chapterId: string
  type: LessonType
  name: string
  description: string
  imageFile: any
  id: string
}

export interface IUpdateLesson {
  type: LessonType
  name: string
  description: string
  imageFile: any
  chapterId: string
}

export enum LessonType {
  Lesson = "Lesson",
  Exam = "Exam",
  Challenge = "Challenge",
  Practice = "Practice",
}
